import line from 'src/images/line.png';
const LineSeparation = () => {
    return(
        <>
          <i className="ds-text-primary">
            <img src={line} alt="Logo" style={{height:'1px', width:'99%'}}/>
          </i>
        </>
    )
}
export default LineSeparation;